// extracted by mini-css-extract-plugin
export default {"container--One":"verify-email_container--One__mL9cB","container--div__labelTwo":"verify-email_container--div__labelTwo__kq5ej"};